import { Code2, Github, Linkedin } from "lucide-react";
import type { SocialLink } from "../types/content";

export const socials: SocialLink[] = [
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/bodavamshikumar",
    icon: Linkedin,
  },
  {
    label: "GitHub",
    href: "https://github.com/thvvamshi",
    icon: Github,
  },
  {
    label: "LeetCode",
    href: "https://leetcode.com/u/bodavamshi/",
    icon: Code2,
  },
];
